module.exports = __webpack_public_path__ + "static/media/11B.0244c77e.png";